export default "__VITE_ASSET__BBlAQpg$__"